import TableCellContent, { TableCellContentProps } from "ds/components/Table/Row/CellContent";

import IntentProjectResourcesTableModuleGroupToggle from "./ModuleGroupToggle";

type IntentProjectResourcesTableGroupCellProps = {
  isGroup: boolean;
  isFirst: boolean;
  groupId: string;
  intentProjectId: string;
} & Pick<TableCellContentProps, "children" | "actions" | "role" | "stickyLeft" | "id">;

const IntentProjectResourcesTableGroupCell = ({
  isGroup,
  children,
  isFirst,
  groupId,
  intentProjectId,
  ...cellProps
}: IntentProjectResourcesTableGroupCellProps) => {
  const isActive = isFirst && isGroup;

  return (
    <TableCellContent {...cellProps}>
      {isActive ? (
        <IntentProjectResourcesTableModuleGroupToggle
          groupId={groupId}
          intentProjectId={intentProjectId}
        >
          {children}
        </IntentProjectResourcesTableModuleGroupToggle>
      ) : (
        children
      )}
    </TableCellContent>
  );
};

export default IntentProjectResourcesTableGroupCell;
